import React from 'react'
import { CustomerEndFlowManager } from '../services/endflowmanager/Customer.EFM'
import { IEndFlowManager } from '../services/endflowmanager/EndFlowManager'

const ContextEndFlowManager = React.createContext<
    [IEndFlowManager] | undefined
>(undefined)

export const ProviderEndFlowManager = ({
    endFlowManager,
    children,
}: {
    endFlowManager?: IEndFlowManager
    children: JSX.Element
}): JSX.Element => {
    const EFM = endFlowManager ? endFlowManager : new CustomerEndFlowManager()

    return (
        <ContextEndFlowManager.Provider value={[EFM]}>
            {children}
        </ContextEndFlowManager.Provider>
    )
}

export const useEndFlowManager = (): [IEndFlowManager] => {
    const EFM = React.useContext(ContextEndFlowManager)
    if (!EFM)
        throw new Error('EFM must be accessed through ProviderEndFlowManager')
    return EFM
}
